import { Link } from 'react-router-dom';
import { stats, testimonials } from '@/mocks/site';

export default function BrandStrip() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] text-primary-600 uppercase">
            <span className="w-5 h-[2px] bg-primary-500 rounded-full" />
            关于与口碑
          </span>
          <h2 className="mt-3 font-heading font-black text-2xl md:text-3xl text-foreground-950 leading-snug">
            我们只做一件事：把关系讲清楚
          </h2>
          <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
            911吃瓜不生产结论，只负责把公开信息整理成可读的图谱与时间线。每条关系都标注类型，每条回应都写明来源，让每一次围观都有据可查。
          </p>

          <div className="mt-7 grid grid-cols-2 gap-4">
            {stats.map((item) => (
              <div key={item.label} className="bg-background-100 border border-background-200 rounded-lg p-4">
                <p className="font-heading font-black text-xl md:text-2xl text-primary-700">
                  {item.value}
                  <span className="text-xs font-medium text-foreground-500 ml-1">{item.suffix}</span>
                </p>
                <p className="mt-1 text-xs text-foreground-600">{item.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 text-background-50 font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            <i className="ri-information-line" />
            了解我们的内容原则
          </Link>
        </div>

        <div className="lg:col-span-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {testimonials.map((item, index) => (
              <figure
                key={item.name}
                className={`rounded-lg p-5 border flex flex-col ${
                  index % 2 === 0
                    ? 'bg-secondary-50 border-secondary-200'
                    : 'bg-background-100 border-background-200'
                }`}
              >
                <div className="flex items-center gap-1 text-secondary-600">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <i key={s} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-7 text-foreground-700 flex-1">
                  “{item.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}